import { post } from './request'

export function enterLeaveList(data) {
  return post('/api/EnterLeave/List', data)
}
